import React, { Component } from 'react';
import { connect } from 'react-redux';
import ExpansionPanel, {
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from '@material-ui/core/ExpansionPanel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { GetApplicationOfferDetails } from '../../actions/loanOffer';
import {Line, Bar} from 'react-chartjs-2';
import Hidden from '@material-ui/core/Hidden';

const styles = {
    errorStyle: {
    
    }
  };


  const mapStateToProps = (state) => {
    // console.log('mapStateToProps');
    // console.log(state);    
    return {        
            application: state.application,
            offer: state.offer

    };
  };
  
const mapDispatchToProps = (dispatch) => {
    return {
     getDetails: (app) => dispatch(GetApplicationOfferDetails(app)),      
 }} 

class LoanPaymentDetails extends Component {       

    constructor(props) {
        super(props);    
        this.state = {
          expanded: false
        };
        this.handleChange = this.handleChange.bind(this);
      }

componentDidMount = () => 
{
  if (this.props.len !== undefined && this.props.amt !== undefined)
    this.props.getDetails({len: this.props.len, amt: this.props.amt});
  else if (this.props.offer.len !== undefined && this.props.offer.amtp !== undefined)
    this.props.getDetails({len: this.props.offer.len, amt: this.props.offer.amt});
  else if (this.props.application.loanLength !== undefined && this.props.application.loanAmount !== undefined)    
    this.props.getDetails({len: this.props.application.loanLength, amt: this.props.application.loanAmount});  

  if (this.props.open === true)
    this.setState({expanded: true});
  
}
handleChange = () => {
  this.setState({expanded: !this.state.expanded})
}
render () {

  const data = {
    labels: this.props.offer.offerdata.pmtslabels,
    datasets: [
      {
        data: this.props.offer.offerdata.capitals,
        label: 'maksuerä',
        backgroundColor: 'rgba(14,25,75,1)',        
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(255,99,132,0.7)',
        hoverBorderColor: 'rgba(255,99,132,1)',       
      }
      /*
      ,
      {
        data: this.props.offer.offerdata.interests,
        label: 'korko',
        borderWidth: 1,
        hoverBorderColor: 'rgba(255,99,132,1)',   
        hoverBackgroundColor: 'rgba(255,99,132,0.4)',
        // backgroundColor: 'rgba(0, 132, 198, 0.3)'
        // backgroundColor: 'rgba(14, 47, 107, 0.3)'
        backgroundColor: 'rgba(14,25,75,1)',        
        
      },
      */
    ] 
  }
  const options = {
    scales: {
      xAxes: [{
        stacked: true,
      }],
      yAxes: [{
        stacked: true
      }]
    },
    legend: {
      display: false,
  },

  }
  
    return (           

        <div className="" style={{fontFamily: "Inter, sans-serif"}}>
      {/*

        <ExpansionPanel expanded={this.state.expanded} onChange={() => {this.handleChange()}}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        Lainan tiedot ja maksuerät
        </ExpansionPanelSummary>
        <ExpansionPanelDetails >

      */}   
              
            {this.props.offer.offerdata.isFetching === false &&
            <div className="">
         
            <div className="">    
                           
             <div className="row" >
             <div className="col-12 col-xl-12">
            
             
             <div className="row">
                  <div className="col-6">
           
                    <h6>Kuukausierä</h6>
                  </div>
                  <div className="col-6">
                 <h5>{this.props.offer?.offerdata?.loanDetails?.monthlyPmt || 0} € 
                 </h5>
                  </div>               
                </div>

                <div className="row" style={{marginTop: "10px"}}>
                  <div className="col-6">
                    <h6>Lainamäärä</h6>
                  </div>
                  <div className="col-6 ">
                    <h5>{this.props.offer.offerdata.loanParameters.loanAmount} €</h5>
                  </div>               
                </div>

                <div className="row" style={{marginTop: "10px"}}>
                  <div className="col-6 ">
                    <h6>Laina-aika</h6>
                  </div>
                  <div className="col-6">
                  <h5>{this.props.offer.offerdata.loanParameters.loanLength} kk</h5>
                  </div>               
                </div>





              {/*
              
              

                <div className="row" style={{marginTop: "10px"}}>
                  <div className="col-6 ">
                    <h6>1. eräpäivä</h6>
                  </div>
                  <div className="col-6">
                  <h5>{this.props.offer.offerdata.loanDetails.firstDueDate.replace('-','.').replace('-','.')}</h5>
                  </div>               
                </div>

              <div className="row" style={{marginTop: "10px"}}>
              <div className="col-6">

              <h6>Lainan avauspalkkio</h6>
                </div>

                <div className="col-6">
                <h5>{this.props.offer.offerdata.loanDetails.openFeePcnt} %  </h5>
                </div>
            </div> 
            */}
            {/*            
            <div className="row" style={{marginTop: "10px"}}>
              <div className="col-md-12">
              {this.props.offer.offerdata.loanParameters.loanAmount <= 7000 && <div><p style={{color: "white", backgroundColor: "navy", padding: "5px", marginTop: "10px"}}>Pikalainapäätös arkisin klo 09:00-19:00 lainamäärän ollessa alle 7000 €</p></div>}
                </div>
          </div>             



             <div className="row" >
                  <div className="col-md-12">
                    <b>Lainamäärä</b>
                  </div>
                </div>
            */}
              
           
          

                {/*                
                <div className="row" >
                  <div className="col-6 col-md-7">
                    Luoton nostopäivä
                  </div>
                  <div className="col-6 col-md-5" style={{textAlign: "right;"}}>
                  <b>
                 {new Intl.DateTimeFormat('sv-SE', { 
                    year: 'numeric', 
                    month: '2-digit', 
                    day: '2-digit' 
                  }).format(Date.now())}
                  </b>
                  </div>               
                </div>
                */}
               
            

               
             </div>
             
{/*
             <div className="col-12 col-md-4">
             
                <div className="row" >
                  <div className="col-6 col-md-8">
                    Todellinen vuosikorko (sis. kulut)
                  </div>
                  <div className="col-6 col-md-4">
                  {this.props.offer.offerdata.loanDetails.apr} %
                  </div>               
                </div>
                <div className="row" >
                  <div className="col-6 col-md-8">
                    Laina
                  </div>
                  <div className="col-6 col-md-4">
                  <b>Tasaerä</b>
                  </div>               
                </div>
  </div>
  */}

             </div>

 

  
             </div>
             {/*
             <hr/>

             <h1 style={{color: "rgb(45, 75, 122)"}}>Lainan maksuerät</h1>

                <div className="row" >
                  <div className="col-6 col-md-7">
                    Ensimmäinen eräpäivä
                  </div>
                  <div className="col-6 col-md-5" style={{textAlign: "right;"}}>
                  <b>
                  {this.props.offer.offerdata.loanDetails.firstDueDate.replace('-','.').replace('-','.')}
                  </b>
                  </div>               
                </div>

                <div className="row" >
                  <div className="col-6 col-md-7">
                    Viimeinen eräpäivä
                  </div>
                  <div className="col-6 col-md-5" style={{textAlign: "right;"}}>
                  <b>
                  {this.props.offer.offerdata.loanDetails.lastDueDate.replace('-','.').replace('-','.')}
                  </b>
                  </div>               
                </div>
            */}
                        

              {/* <p style={{fontSize: "12px"}}>Laina maksetaan takaisin {this.props.offer.offerdata.loanDetails.monthlyPmt} € erissä kuukausittain.             */}
             

              
              <div className="row" style={{marginTop: "10px"}}>
                  
                  

                  
                  <div className="col-12"  style={{marginTop: "10px"}}>

                  <Hidden smDown>   
                  <p style={{fontSize: "14px", fontWeight: "600"}}>Vaivaton yrityslaina kasvuun ja investointeihin</p>
              <div style={{width: "100%", marginTop: "10px", marginBottom: "10px"}}/>
               
                  <ul style={{listStyleImage: "url(/img/icons8-checkmark-16.png)", paddingLeft: "25px"}}>
                  <li style={{marginBottom: "10px", fontSize: "14px", fontWeight: "600"}}>Maksat vain kuukausierän</li>
                    <li style={{marginBottom: "10px", fontSize: "14px", fontWeight: "600"}}>Ei avauspalkkiota tai kuluja</li>                    
                  
                  </ul>
                  <p style={{fontSize: "13px", marginBottom: "29px"}}>Kokonaiskustannus {this.props.offer.offerdata.loanDetails.totalPmt} €. Kuukausierän lopullinen suuruus tarkentuu riskiarviomme perusteella.                  
                  </p>
                 

              <div style={{width: "100%", marginTop: "20px", marginBottom: "20px"}}/>

                <Bar
              data={data}
              options={options} 
              style={{maxHeight: "100px", marginTop: "40px"}}/>



              <div style={{textAlign: "center", width: "100%"}}>
<img src="/img/front_kasvurahoitus-blue.png" style={{height: "35px", marginTop: "40px"}}/>
</div>

              </Hidden>
              
                    </div>         
                <div className="col-md-12">

                <p className="applyText" style={{marginTop: "30px"}}>               

             </p>
                  </div>
                </div>  
{/*             <p style={{fontSize: "13px"}}>
             Luoton ennenaikainen maksu ja maksuerien muuttaminen on mahdollista 
             maksuohjelman aikana. Lopullinen kuukausierä vahvistuu riskiarviomme perusteella, ja voi olla pienempi tai suurempi kuin alustava tarjouksemme.</p>
             <p style={{fontSize: "13px"}}> Front Kasvurahoitus yrityslaina myönnetään aina omevelkaisella takauksella.
</p>
 {this.props.offer.offerdata.loanParameters.loanAmount > 20000 && <p style={{fontSize: "12px"}}>
  Yli 20 000 euron luotonmyöntäjänä toimii <b>Front Finance Oy</b>.<br/>
  </p>}
  {this.props.offer.offerdata.loanParameters.loanAmount <= 20000 && <p style={{fontSize: "12px"}}>
  Alle 20 000 euron luotonmyöntäjänä toimii <b>Vertaislaina Oy</b>.<br/>
  </p>}
    */}         
            </div>


        }
        {/*
        </ExpansionPanelDetails>
      </ExpansionPanel>
        */}

        </div>   
  
    )
 }
}

export default connect(mapStateToProps,mapDispatchToProps)(LoanPaymentDetails);    

    
